import React from 'react';
import PropsTypes from 'prop-types';
import { CheckIcon } from '@heroicons/react/outline';

import { getFullName } from '../../../../utils';
import WithPermission from '../../../with-permission';

const MMRButton = ({ disabled, label, className, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={className}
  >
    {label}
  </button>
)

const TableRow = ({
  row, isChecked, companyId, toggleHubs, onClickEmails, onClickManagers,
}) => {

  const getEmails = () => {
    const { ivmr_external_emails } = row?.pivot || {};
    if (ivmr_external_emails?.length > 0) {
      return ivmr_external_emails.split(';').slice(0, 4).join(',');
    }
    return 'Set emails';
  };

  const getResponsible = () => {
    const { ivmr_managers: managers } = row?.pivot;
    if (managers?.length > 0) {
      if (managers.length === 1) return getFullName(managers[0]);
      const managerListNames = managers.map((manager) => getFullName(manager)).join(', ');
      return managerListNames;
    }
    return 'Select Manager';
  };

  return (
    <tr
      key={`${row.id} ${row?.pivot?.company_id}`}
      className="whitespace-wrap text-sm text-gray-900"
    >
      <td className="px-2 py-3">
        <div className="flex">
          <label
            className={`mr-2 flex font-medium text-green-regular
                        ${companyId === null ? 'opacity-50' : 'cursor-pointer'}`}
          >
            <div className={`flex items-center justify-center h-5 w-5 rounded-full
              ${isChecked ? 'bg-green-100' : 'bg-gray-100'}`}
            >
              <CheckIcon
                className={`h-3 w-3 text-${isChecked ? 'green' : 'gray'}-600`}
                aria-hidden="true"
              />
            </div>
            <div className={`${isChecked ? 'text-green-600' : 'text-gray-600'} ml-2`}>
              {`${row.name} (${row.external_id || ''})`}
            </div>
            <input
              name={row.name}
              type="checkbox"
              disabled={companyId === null}
              checked={isChecked}
              onChange={() => toggleHubs(row)}
              className="focus:ring-indigo-500 h-4 w-4
                                text-indigo-600 border-gray-300 rounded hidden"
              data-testid="check-box"
            />
          </label>
        </div>
      </td>

      <WithPermission permissionsCheck={['CompaniesResources', 'MMR']}>
        <td className="px-2 py-3 break-all">
          <MMRButton
            label={getEmails()}
            className="font-medium text-green-regular text-left flex flex-wrap"
            onClick={onClickEmails}
            disabled={companyId === null}
          />
        </td>
        <td className="px-2 py-3">
          <MMRButton
            label={getResponsible()}
            className="font-medium text-green-regular text-left"
            onClick={onClickManagers}
            disabled={companyId === null}
          />
        </td>
      </WithPermission>
    </tr>
  );
};

TableRow.propTypes = {
  row: PropsTypes.object.isRequired,
  isChecked: PropsTypes.bool.isRequired,
  companyId: PropsTypes.oneOfType([PropsTypes.string, PropsTypes.number]).isRequired,
  toggleHubs: PropsTypes.func.isRequired,
  onClickEmails: PropsTypes.func.isRequired,
  onClickDate: PropsTypes.func.isRequired,
  onClickManagers: PropsTypes.func.isRequired,
};

export default TableRow;
